export default function Logo({ type = 'logo', className = '', ...props }) {
    let logoSrc = '/images/logo/logo.png'
    let maxW = 'max-w-44'

    if (type === 'dark') {
        logoSrc = '/images/logo/logo-dark.png'
    } else if (type === 'icon') {
        logoSrc = '/images/logo/logo-icon.png'
        maxW = 'w-8'
    }

    return <img src={logoSrc} alt={type} className={`${maxW} ${className}`} {...props} />
}
